if (!customElements.get("variant-picker")) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
    }

    get selectedOptionValues() {
      const options = this.querySelectorAll('.m-product-option select, .m-product-option input');
      const selectedValues = new Map();

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (field.tagName.toLowerCase() === "select") {
          const selectedOption = Array.from(field.options).find(
            (opt) => opt.selected && !opt.disabled
          );
          if (selectedOption) {
            selectedValues.set(fieldName, selectedOption.dataset.optionValueId);
          }
        } else if (
          field.tagName.toLowerCase() === "input" &&
          field.type === "radio"
        ) {
          const checkedInput = field.checked ? field : null;
          if (checkedInput) {
            selectedValues.set(fieldName, checkedInput.dataset.optionValueId);
          }
        }
      });

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (!selectedValues.has(fieldName)) {
          if (field.tagName.toLowerCase() === "select") {
            const firstValidOption = Array.from(field.options).find(
              (opt) => !opt.disabled
            );
            if (firstValidOption) {
              selectedValues.set(
                fieldName,
                firstValidOption.dataset.optionValueId
              );
            }
          } else if (
            field.tagName.toLowerCase() === "input" &&
            field.type === "radio"
          ) {
            const firstInput = field;
            if (firstInput) {
              selectedValues.set(fieldName, firstInput.dataset.optionValueId);
            }
          }
        }
      });

      const result = [];
      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;
        if (selectedValues.has(fieldName)) {
          const optionValueId = selectedValues.get(fieldName);
          if (optionValueId && !result.includes(optionValueId)) {
            result.push(optionValueId);
          }
        }
      });
      return result;
    }

    connectedCallback() {
      this.addEventListener('change', (event) => {
        const target = this.getInputForEventTarget(event.target);
        MinimogEvents.emit(MinimogTheme.pubSubEvents.optionValueSelectionChange, {
          data: {
            selectedOptionValues: this.selectedOptionValues,
            event,
            target
          }
        });

        const variant = window.MinimogTheme?.ProductData?.variants?.find(v =>
          this.selectedOptionValues.every(id =>
            v.option_value_ids.includes(Number(id))
          )
        );

        if (variant) {
          this.currentVariant = variant;

          // Cálculo de PIX
          const priceWithDiscountPix = updatePixDiscount(this.currentVariant.price, discountPix);

          // Cálculo de parcelas
          updateInstallments(this.currentVariant.price, maximoDeParcelas, valorMinimoDaParcela);
        }
      });
    }

    getInputForEventTarget(target) {
      return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
    }
  }

  customElements.define("variant-picker", VariantPicker);
}

// Função de cálculo de parcelas
function updateInstallments(priceInCents, maximoDeParcelas, valorMinimoDaParcela) {
  let numInstallments = maximoDeParcelas;
  let installmentValue = priceInCents / numInstallments;
  const valorMinimoDaParcelaEmCentavos = valorMinimoDaParcela * 100;

  while (installmentValue < valorMinimoDaParcelaEmCentavos && numInstallments > 1) {
    numInstallments--;
    installmentValue = priceInCents / numInstallments;
  }

  const parcelasElement = document.getElementById("parcelas-encontradas-product");
  const valorParcelaFinalElement = document.getElementById("valor-parcela-final-product");

  if (parcelasElement) {
    parcelasElement.innerHTML = numInstallments;
  }
  if (valorParcelaFinalElement) {
    valorParcelaFinalElement.innerHTML = formatMoney(installmentValue, window.MinimogSettings.money_format);
  }
}
